import { Flex, Image, Text } from "@chakra-ui/react";
import React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MilestoneBadge = _ref => {
  let {
    icon,
    title,
    flexProps,
    classNames = ""
  } = _ref;
  return /*#__PURE__*/_jsxs(Flex, {
    px: 3,
    pb: 0.5,
    gap: 1.5,
    width: "fit-content",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2xl",
    className: classNames || "bg-gitcoin-violet-100 text-gitcoin-violet-400",
    ...flexProps,
    children: [!!icon && /*#__PURE__*/_jsx(Image, {
      src: icon,
      alt: "flag-icon.svg",
      boxSize: 4,
      mt: 1
    }), /*#__PURE__*/_jsx(Text, {
      children: title
    })]
  });
};